import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import Public from "../Layouts/Public";
import Card from "../components/Card/Card";
import ContactForm from "../components/Form/ContactForm";
import PageSection, { StyledSectionHeading } from "../components/PageSection";
import Spacer from "../components/Spacer";
import { siteTitle } from "../data/PublicSiteData";
import { trackPageView } from "../includes/analytics";
import { Color } from "../theme/Color";
import { RoundedCorners } from "../theme/Mixins";

const StyledButtonHintRow = styled(Row)`
  text-align: center;
  color: ${Color.White};
`;

const StyledEmailRow = styled(Row)`
  background: ${Color.Beige};
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  ${RoundedCorners}
  & a {
    color: ${Color.Blue5};
  }
`;

const Contact = () => {
  const router = useRouter();

  trackPageView("/contact");

  return (
    <>
      <NextSeo
        title={`Contact | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <PageSection
        backgroundColor={Color.White}
        width="1340px"
        data-cy="core-values"
      >
        <StyledSectionHeading center="xs">Contact</StyledSectionHeading>
        <Row center="xs">
          <Col xs={12} md={6} style={{ color: "black" }}>
            <Spacer bottom={8}>
              <Card hasPadding title="Contact Us">
                <Col xs={12}>
                  <ContactForm />
                </Col>
              </Card>
            </Spacer>
          </Col>
        </Row>
        <Row center="xs" middle="xs" style={{ color: Color.Black }}>
          <Col xs={12} md={6}>
            <Card
              hasPadding
              title="OR contact us directly at these email addresses."
              titleIsCentered
            >
              <Col xs={12}>
                <p>
                  We would really appreciate your feedback: your suggestions,
                  bugs you find, features for the future or anything else you
                  might thing of.
                </p>

                <StyledEmailRow center="xs">
                  <Link href="mailto:info@valmeego.com">info@valmeego.com</Link>
                </StyledEmailRow>
                <StyledEmailRow center="xs">
                  <Link href="mailto:gerard@valmeego.com">
                    gerard@valmeego.com
                  </Link>
                </StyledEmailRow>
                <StyledEmailRow center="xs">
                  <Link href="mailto:naoimh@valmeego.com">
                    naoimh@valmeego.com
                  </Link>
                </StyledEmailRow>
                <StyledEmailRow center="xs">
                  <Link href="mailto:marketing@valmeego.com">
                    marketing@valmeego.com
                  </Link>
                </StyledEmailRow>
                <StyledEmailRow center="xs">
                  <Link href="mailto:ceo@valmeego.com">ceo@valmeego.com</Link>
                </StyledEmailRow>
              </Col>
            </Card>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

Contact.Layout = Public;
Contact.Title = "Contact | Valmeego - Locally and beyond";

export default Contact;
